import React from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import BankAccount from "../../components/BankAccount";
import config from "../../config";
import { Constants } from "../../libs/Constants";
import { update } from "../../libs/dbFunctions";
import { placeEvent } from "../../libs/eventsLib";
import useEmployeeContext from "./contexts/useEmployeeContext";
const configObj = config.getConfigObject();

const AddBankAccountButton = ({ onSuccess, openModal }) => {
  const { employee } = useEmployeeContext();
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  const handleSuccess = async (response) => {
    let bankInfo = null;
    if (configObj.bank_integration === "dwolla") {
      let details = response["_links"]["funding-source"]["href"].split("/");
      bankInfo = details[details.length - 1];
    }
    if (configObj.bank_integration === "plaid") {
      bankInfo = response.token ? response.token : null;
    }
    let saveFields = {
      id: employee.id,
      bank_information: bankInfo,
    };
    //update the userObj with salary and flags
    try {
      await update(Constants.dbTypes.USER, saveFields);
      toast.success("Account added successfully");
      await placeEvent(
        Constants.EVENT_TYPES.BANK_ACCOUNT,
        employee.email,
        {
          bankInformation: saveFields.bank_information
        });
      setOpen(false);
      onSuccess();
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>Add Account</Button>
      {employee && (
        <BankAccount
          title={"Add Bank account"}
          show={open}
          onHide={(result, response) => {
            setOpen(false);
            if (response) {
              if (!result) {
                toast.error(response);
              } else {
                handleSuccess(response);
              }
            }
          }}
          userObj={employee}
        />
      )}
    </>
  );
};

export default AddBankAccountButton;
